import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=1e55fd12"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports